import { computed } from "vue";
import { useTargetStore } from "../target/targets.store";
import { useIndexStore } from "../index/indices.store";
import { useStoreItem } from "../itemStore.store";
import { useResourceStore } from "../resource/resources.store";
import { relationStructure, useRelationStore } from "./relations.store";

export const useRelation = useStoreItem(
  relationStructure,
  useRelationStore,
  (_relation, store) => {
    const targetStore = useTargetStore();
    const resourceStore = useResourceStore();
    const indexStore = useIndexStore();

    const startItem = computed(() => {
      const relation = _relation.value;
      if (relation == null) return null;
      if (relation.startItemType === "target") {
        return targetStore.items[relation.startItemId];
      } else if (relation.startItemType === "resource") {
        return resourceStore.items[relation.startItemId];
      } else {
        return indexStore.items[relation.startItemId];
      }
    });

    const endItem = computed(() => {
      const relation = _relation.value;
      if (relation == null) return null;
      if (relation.endItemType === "target") {
        return targetStore.items[relation.endItemId];
      } else {
        return resourceStore.items[relation.endItemId];
      }
    });

    const graphModel = computed(() => {
      const relation = _relation.value;
      if (relation == null) return null;
      return store.graphModels[relation.id];
    });

    return {
      graphModel,
      startItem,
      endItem
    };
  }
);
